import React from "react";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import ScheduleExerise from "../../ScheduleExercise";

interface IProps {
  saleStep: SaleStep;
}

const FitnessScheduleModule: React.FC<IProps> = ({ saleStep }) => (
  <ScheduleExerise
    embedded
    hideFilters={saleStep.hideFilters}
    defaultExerciseGroup={saleStep.fitnessDefaultExerciseGroup}
    defaultZone={saleStep.fitnessDefaultZone}
    defaultInstructor={saleStep.fitnessDefaultInstructor}
    dateFromValue={saleStep.dateFromValue}
    dateToValue={saleStep.dateToValue}
  />
);

export default FitnessScheduleModule;
